/**
 * Configuration file for Statsig
 */

export default {

  /**
   * Client SDK key for Statsig
   */

  apiKey: 'client-s9BRnYoWOHtURgN46mK0mVUuq3tf8MVXUvAN42l9RYz',

  /**
   * Environment tier to report as
   *
   * Valid values: 'development', 'staging', 'production'
   */

  environment: 'development'

};
